import React, { useEffect, useState } from 'react'
import { Breadcrumb, Button, Divider, Flex, Table, notification, theme } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import BulkUpload from './BulkUpload';
import MasterDataAPI from '../../../restAPI/MasterDataAPI';
import { useSelector } from 'react-redux';

function handleDownload() {
    const csvData = "Name*,Email*,Address,Mobile Number,Branch,Department,Role*,Designation";
    const blob = new Blob([csvData], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "Sample_Bulk_CSV.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

export default function BulkUser() {
    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();
    const { companyId, token } = useSelector(state => state.auth);
    const [isLoading,setIsLoading] = useState(false);
    const [analyzeStatus, setAnalyzeStatus] = useState(false);
    const [api, contextHolder] = notification.useNotification();
    const [fileData, setFileData] = useState(null);
    const [errorData, setErrorData] = useState([])
    const [fileList, setFileList] = useState([])

    const openNotificationWithIcon = (type, message, description, placement) => {
        api[type]({
            message: message,
            description: description,
            placement
        });
    };


    const columns = [
        {
            title: 'Row Index',
            dataIndex: 'row',
            key: 'row',
            sorter: (a, b) => a.row - b.row, // Enables sorting in UI
            defaultSortOrder: 'ascend', // Ensures default ascending order
            render: (text) => text + 1,

        },
        {
            title: 'Reason',
            dataIndex: 'errors',
            key: 'errors',
            render: (text) => (
                <>
                    {text.map((sentence, index) => (
                        <div key={index}>
                            {`${index + 1}: ${sentence}`}
                        </div>
                    ))}
                </>
            ),
        },
    ];

    


    let lastNotified = 0;
    const analyzeHandler = async () => {

        const showNoFileNotification = () => {
            const now = Date.now();
            if (now - lastNotified > 6000) {
                openNotificationWithIcon('error', 'Analyze failed', 'Please select a file first!', 'bottomLeft');
                lastNotified = now;
            }
        };

        if (!fileData) {        
            showNoFileNotification(); 
            return;
        }
        setIsLoading(true);
        const formData = new FormData();
        formData.append('file', fileData);

        try {
            const res = await MasterDataAPI.analyzeFile(formData, companyId, token);

            setAnalyzeStatus(true);
            setErrorData([]);
            openNotificationWithIcon('success', 'Analyze successful', res.message, 'bottomLeft');

        } catch (err) {      
            console.log(err)      
            setAnalyzeStatus(false); 
            
            if(err?.response?.data?.statusCode==422){
                const { message, data } = err.response.data;     
                setErrorData([]);
                if (Array.isArray(data)) {
                    setErrorData(data);
                }
                openNotificationWithIcon('error', 'Analyze failed',"No data found in the uploaded file", 'bottomLeft');
            }
            else if (err?.response?.data?.message) {
                const { message, data } = err.response.data;                
                if (Array.isArray(data)) {
                    setErrorData(data);
                }
                openNotificationWithIcon('error', 'Analyze failed',message, 'bottomLeft');
            } else if (err.message) {            
                openNotificationWithIcon('error', 'Analyze failed', err.message, 'bottomLeft');
            } else {            
                openNotificationWithIcon('error', 'Analyze failed', 'An unexpected error occurred.', 'bottomLeft');
            }
        }finally{
            setIsLoading(false);
        }
    };




    //initial 
    // const uploadHandler = async () => {
    //     console.log('upload', fileData)
    //     setIsLoading(true);
    //     const formData = new FormData();
    //     formData.append('file', fileData);
    //     await MasterDataAPI.uploadFile(formData, companyId, token).then((res) => {
    //         setAnalyzeStatus(false);
    //         openNotificationWithIcon('success', 'Upload successful', `${res.message}`, 'bottomLeft');
    //         setFileData(null);
    //         setFileList([]);
    //     }).catch((err) => {
    //         if (err.response.data.message) {
    //             openNotificationWithIcon('error', 'Upload failed', `${err.response.data.message}`, 'bottomLeft');
    //         } else {
    //             openNotificationWithIcon('error', 'Upload failed', `${err.message}`, 'bottomLeft');
    //         }
    //     })
    // };

    //v1
    const uploadHandler = async () => {
        if (!fileData) {
            openNotificationWithIcon('error', 'Upload failed', 'No file selected', 'bottomLeft');
            return;
        }
        
        setIsLoading(true);

        try {
            const formData = new FormData();
            formData.append('file', fileData);

            const res = await MasterDataAPI.uploadFile(formData, companyId, token);

            openNotificationWithIcon('success', 'Upload successful', res.message, 'bottomLeft');

            
            setAnalyzeStatus(false);
            setFileData(null);
            setFileList([]);
        } catch (err) {
            const errorMessage = err?.response?.data?.message || err.message || 'Unknown error occurred';
            openNotificationWithIcon('error', 'Upload failed', errorMessage, 'bottomLeft');
        } finally {
            setIsLoading(false);
        }
    };


    const cancelHandler = () => {
        setAnalyzeStatus(false);
        setFileData(null);
        setFileList([]);
    };

    useEffect(() => {
        if (!fileData) {
            setErrorData([]);
            setAnalyzeStatus(false)
        }
    }, [fileData])



    return (
        <>
            <Flex gap={20} justify='space-between' align='center' style={{
                margin: '16px',
                padding: '16px 24px',
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                <Breadcrumb
                    items={[
                        {
                            title: <HomeOutlined />,
                        },
                        {
                            title: (
                                <>
                                    User
                                </>
                            ),
                        },
                        {
                            title: 'Bulk User',
                        },
                    ]}
                />
                <Button onClick={handleDownload}>
                    Sample CSV
                </Button>
            </Flex>
            <div style={{
                margin: '16px',
                padding: 24,
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                <BulkUpload fileData={fileData} setFileData={setFileData} fileList={fileList} setFileList={setFileList} analyzeStatus={analyzeStatus} />
                <br />
                <Flex align='center' justify='flex-end' gap={16}>
                    {/* <Button onClick={handleClear}>Clear</Button> */}
                    {analyzeStatus && 
                        <Button onClick={cancelHandler}>
                            Cancel
                        </Button> }

                    <Button type="primary" onClick={!analyzeStatus ? analyzeHandler : uploadHandler}                         
                        loading={isLoading}
                    >
                        {!analyzeStatus ? "Analyze" : "Upload"}
                    </Button>
                </Flex>
                {errorData.length > 0
                    && (
                        <>
                            <br />
                            <Divider>Failed Users</Divider>
                            <Table
                                columns={columns}
                                dataSource={errorData}
                                scroll={{ x: 'max-content' }}

                            />
                        </>
                    )
                }
            </div>
            {contextHolder}
        </>
    )
}